// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"e086e54d","787":"4809d29d"}[chunkId] + ".chunk.js";
};